import { MAX_ALLOWED_COMMUNITIES } from '../model/community.constants';

export const CommunitiesPageSkeleton = () => (
  <div
    data-testid="communities-page-skeleton"
    aria-busy="true"
    className="flex w-full flex-col gap-7"
  >
    <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-2">
        <div className="h-8 w-40 animate-pulse rounded-lg bg-[#E4E4E4]" />
        <div className="h-5 w-20 animate-pulse rounded-[26px] bg-[#E4E4E4]" />
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <div className="h-10 w-28 animate-pulse rounded-lg bg-[#E4E4E4]" />
        <div className="h-10 w-24 animate-pulse rounded-lg bg-[#E4E4E4]" />
        <div className="h-10 w-32 animate-pulse rounded-lg bg-[#E4E4E4]" />
      </div>
    </div>
    <div className="grid grid-cols-1 items-stretch gap-4 lg:grid-cols-3 lg:gap-[44px]">
      {Array.from({ length: MAX_ALLOWED_COMMUNITIES }, (_, index) => (
        <div
          key={index}
          className="h-[72px] animate-pulse rounded-lg bg-[#E4E4E4]"
        />
      ))}
    </div>
  </div>
);
